/* eslint-disable react-hooks/exhaustive-deps */
import { useWindowSize } from '@react-hook/window-size';
import { ConfigProvider } from 'antd';
import AOS from 'aos';
import axios from 'axios';
import React, { Suspense, useContext, useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { ReactNotifications } from 'react-notifications-component';
import { useNavigate } from 'react-router-dom';
import myInfoApi from '../../apis/auth/myInfoApi';
import Loading from '../../common/loading/Loading';
import GeneralSettingsContext from '../../contexts/general-settings-context/GeneralSettingsContext';
import MyNotificationsContext from '../../contexts/notifications-context/MyNotificationsContext';
import UserContext from '../../contexts/user-context/UserProvider';
import useCustomApiRequest from '../../custom-hooks/useCustomApiRequest';
import useGeneralSettings from '../../custom-hooks/useGeneralSettings';
import { onMessageListener } from '../../firebase';
import '../../i18n';
import DocTitleScrollTop from '../../utils/DocTitleScrollTop';
import checkRes from '../../utils/checkRes';
import ForegroundNotifications from '../foreground-notification/ForegroundNotification';
import Routes from './Routes';
import routerLinks from './routerLinks';
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

function App() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { fetchUserCount, user, removeCurrentUser, setCurrentUser } =
    useContext(UserContext);
  const { setWindowGutterWidth } = useContext(GeneralSettingsContext);

  // console.log('user : ', user);
  useEffect(() => {
    document.documentElement.dir = i18n.dir();
    document.body.dir = i18n.dir();
  }, [i18n.dir()]);

  useEffect(() => {
    AOS.init({
      duration: 1500
    });
  }, []);
  const {
    isLoadingGeneralSettings,
    setIsLoadingGeneralSettings,
    fetchGeneralSettingsCount,
    setFetchGeneralSettingsCount,
    fetchedGeneralSettings,
    setFetchedGeneralSettings
  } = useContext(GeneralSettingsContext);
  useGeneralSettings({
    isLoading: isLoadingGeneralSettings,
    setIsLoading: setIsLoadingGeneralSettings,
    fetchCount: fetchGeneralSettingsCount,
    setFetchCount: setFetchGeneralSettingsCount,
    fetchedSettings: fetchedGeneralSettings,
    setFetchedSettings: setFetchedGeneralSettings
  });
  // const location = useGeoLocation();
  // useEffect(() => {
  //   Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
  //   Geocode.setLanguage(i18n.language);
  // }, [location?.loaded, i18n.language]);

  DocTitleScrollTop('');

  const customApiRequest = useCustomApiRequest();
  // console.log('user : ', user);
  useEffect(() => {
    let isMounted = true;
    if (user) {
      customApiRequest(
        myInfoApi(user?.token, i18n.language),
        (res) => {
          if (isMounted) {
            if (checkRes(res)) {
              setCurrentUser({
                ...res?.data?.data,
                token: user?.token,
                accountType: user.accountType,
                activated: user.activated
              });
            } else {
              removeCurrentUser();
              navigate(routerLinks?.signinPage);
            }
          }
        },
        (error) => {}
      );
    }
    return () => {
      isMounted = false;
    };
  }, [fetchUserCount]);

  // useEffect(() => {
  //   moment.locale(i18n.language);
  // }, [i18n.language]);

  // FCM
  const {
    setFcmNotificationFetchCount,
    fcmNotificationPayload,
    fcmNotificationFetchCount,
    setFetchCount,
    setFcmNotificationPayload
  } = useContext(MyNotificationsContext);

  if (onMessageListener()) {
    onMessageListener()
      .then((payload) => {
        // console.log('payload : ', payload);
        setFcmNotificationFetchCount((prev) => prev + 1);
        setFetchCount((prev) => prev + 1);
        setFcmNotificationPayload({
          // title: payload.notification.title,
          // body: payload.notification.body
          ...payload
        });
      })
      .catch((err) => console.log('failed: ', err));
  }

  const [width] = useWindowSize();
  useEffect(() => {
    const gutterWidth = window.innerWidth - width;

    setWindowGutterWidth(gutterWidth.toString());
    if (window.innerWidth > width)
      document.documentElement.setAttribute(
        'gutter',
        gutterWidth.toString() ?? ''
      );
  }, [width]);

  return (
    <div className={`app app-${i18n.dir()}`}>
      <Suspense fallback={<Loading />}>
        <HelmetProvider>
          <ConfigProvider
            direction={i18n.dir()}
            // locale={i18n?.language === 'ar' ? arEg : enUs}
            theme={{
              token: {
                fontSize: 14,
                colorPrimary: '#9d4edd',
                fontFamily: `'DroidKufi-Regular', 'Poppins-Regular' !important`
              }
            }}
          >
            <ReactNotifications />

            {user && (
              <ForegroundNotifications
                fcmNotificationPayload={fcmNotificationPayload}
                fcmNotificationFetchCount={fcmNotificationFetchCount}
                setFcmNotificationFetchCount={setFcmNotificationFetchCount}
                setFcmNotificationPayload={setFcmNotificationPayload}
                setFetchCount={setFetchCount}
              />
            )}
            <Routes />
          </ConfigProvider>
        </HelmetProvider>
      </Suspense>
    </div>
  );
}

export default App;
